import { createActions, createReducer } from 'reduxsauce'

import DeducoesService from '../../servicos/DetalhesRemuneracaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDeducoesInicio: [],
    buscaDeducoesSucesso: ['deducoes'],
    buscaDeducoesErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaDeducoes = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDeducoesInicio())
        let serv = new DeducoesService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaDeducoesSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDeducoesErro(error)))
    }
}

const buscaDeducoesInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDeducoesErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDeducoesSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.deducoes, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DEDUCOES_INICIO]: buscaDeducoesInicio,
    [Types.BUSCA_DEDUCOES_ERRO]: buscaDeducoesErro,
    [Types.BUSCA_DEDUCOES_SUCESSO]: buscaDeducoesSucesso,
})
